// Export modal field name → backend column key (PROLINE-3959 contract).
// `manualDeductionAmount` has no backend key, so it is left out of the log.
const EXPORT_FIELD_LOG_KEYS = {
  name: "applicant_name",
  id: "id",
  days: "days",
  payrollDays: "payroll_days",
  autoDeduction: "auto_deduction",
  manualDeduction: "manual_deduction",
  manualDeductionReason: "manual_deduction_reason",
  reward: "reward",
  rewardReason: "reward_reason",
  numberOfTrainingDays: "number_of_training_days",
  trainingPayPerDay: "training_payroll_per_day",
  totalTrainingPay: "total_training_payroll",
  totalAmount: "total_amount",
  stcNumber: "stc_number",
  iqamaId: "national_id",
  training: "training",
  transferCommission: "transfer_commission",
  signature: "signature",
  role: "role",
};

/** Body for `log_payroll_export`: the report period as shown, and the exported column keys in order. */
export const buildPayrollExportLogBody = ({ startDate, endDate, selectedFields, fields }) => {
  const logFields = fields
    .filter((field) => selectedFields[field.name])
    .map((field) => EXPORT_FIELD_LOG_KEYS[field.name])
    .filter(Boolean);

  return {
    ...(startDate ? { start_date: startDate } : {}),
    ...(endDate ? { end_date: endDate } : {}),
    ...(logFields.length ? { fields: logFields } : {}),
  };
};
